import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
  Input,
  ChangeDetectorRef,
  ComponentFactoryResolver,
  OnDestroy,
  inject,
  DestroyRef
} from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { ConversationsService } from "../conversations.service";
import { DashboardService } from "../../dashboard.service";
import { ClientService } from "../../main/client/client.service";
import { DomSanitizer } from "@angular/platform-browser";

import { Conversation, FileItem } from "./conversation.model";
import { WorkspacesService } from "../../main/accountant/workspaces.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FilePreviewDirective } from "../../main/common/file-preview.directive";
import { RecentFilesComponent } from "../../main/panels/recent-files.component";
import { ChatComponent } from "../chat/chat.component";
import { NgClass } from "@angular/common";
import { PaidOverlayDirective } from "../../paid-overlay.directive";

declare var jQuery: any;

@Component({
    selector: "app-chat-panel",
    templateUrl: "./chat-panel.component.html",
    styleUrls: ["../../main/accountant/workspaces.component.scss"],
    imports: [
        PaidOverlayDirective,
        NgClass,
        ChatComponent,
        RecentFilesComponent,
        FilePreviewDirective,
    ]
})
export class ChatPanelComponent implements OnInit, AfterViewInit, OnDestroy {
  user: any = this.localStorage.get("user");
  data: any = this.localStorage.get("data");

  conversationArchived: boolean;
  explorer: any;
  fileForm: FormData = new FormData();
  has_file = false;
  file_name = "";
  file_ext = "";
  upload_loading: boolean;
  chat: any;
  chatName: any;
  conversationsListOpen = true;

  showChat = true;
  showFiles = false;

  @Input() conversation: Conversation = null;
  readonly destroyRef = inject(DestroyRef);

  constructor(
    private localStorage: LocalStorageService,
    private _sanitizer: DomSanitizer,
    private workspaceService: WorkspacesService
  ) {}

  ngOnInit(): void {
    this.workspaceService.$conversation
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((conversation) => {
        this.conversation = conversation;
      });
  }

  ngOnDestroy(): void {
    // No need to manually unsubscribe
  }

  ngAfterViewInit(): void {}

  sanitize(image) {
    return this._sanitizer.bypassSecurityTrustUrl(`${image}`);
  }

  switchChatTabs(tab): void {
    this.showChat = false;
    this.showFiles = false;
    if (tab == "chat") {
      this.showChat = true;
    }
    if (tab == "files") {
      this.showFiles = true;
    }
  }
}
